import { Stack, styled, Typography } from '@mui/material'
import { getFileUrl } from '@weblite/file'
import { BookmarkIcon } from '$common/icons'
import { t } from '$i18n'

const TitleRoot = styled(Stack)`
  margin-right: 12px;
`

const CollectionCoverContainer = styled(Stack)(({ theme }) => ({
  width: '56px',
  height: '56px',
  overflow: 'hidden',
  borderRadius: '4px',
  flexShrink: 0,
  backgroundColor: theme.palette.veryLightGray,

  alignItems: 'center',
  justifyContent: 'center',
}))

const CollectionCoverImage = styled('img')`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

export function BookmarkListItem({
  title,
  contentCount,
  selected,
  onClick,
  cover,
}: {
  title: string
  contentCount: number
  selected: boolean
  onClick: () => unknown
  cover: string
}) {
  return (
    <Stack
      direction="row"
      height="72px"
      width="100%"
      sx={{
        boxSizing: 'border-box',
        border: selected ? '2px solid #55A6FF' : '1px solid #F3F3F3',
        cursor: 'pointer',
      }}
      padding={selected ? '8px 11px' : '8px 12px'}
      alignItems="center"
      borderRadius="8px"
      onClick={onClick}
    >
      <CollectionCoverContainer>
        {cover ? (
          <CollectionCoverImage src={getFileUrl(cover)} />
        ) : (
          <BookmarkIcon sx={{ color: 'rgba(0, 0, 0, 0.1)' }} />
        )}
      </CollectionCoverContainer>
      <TitleRoot width="100%" height="45px" gap="8px" overflow="hidden">
        <Typography
          noWrap
          variant="subtitle3"
          color="semiBlack"
          sx={{ lineHeight: '20px' }}
        >
          {title}
        </Typography>
        <Typography variant="caption1" color="gray" sx={{ lineHeight: '20px' }}>
          {contentCount
            ? t('bookmarkSelectionListModal.contentCount')(contentCount)
            : t('bookmarkSelectionListModal.noContent')}
        </Typography>
      </TitleRoot>
    </Stack>
  )
}
